import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import * as cssSelectorParserUtility from "utilities/community/css-selector-parser-utility/1.0.0/js/css-selector-parser-utility";
/**
 * Responsive content helper.
 * Author: Sunny Singh (zktuuyv)
 */

// List of valid breakpoints.
const BREAKPOINTS = [
  'small-only',
  'small-up',
  'medium-only',
  'medium-up',
  'large-only',
  'large-up',
  'xlarge-only',
  'xlarge-up',
  'xxlarge-only',
  'xxlarge-up',
];

// List of short breakpoints which are converted to a valid breakpoint.
const ALIASES = {
  small: 'small-only',
  medium: 'medium-only',
  large: 'large-only',
  xlarge: 'xlarge-only',
  xxlarge: 'xxlarge-only',
};

// Character used to separate breakpoints.
const BREAKPOINT_SEPARATOR = '|';

// Default tag to render with.
const DEFAULT_TAG = 'span';

// Used to parse custom render selector.
const { parseSelector } = cssSelectorParserUtility;

/**
 * Checks if breakpoint is a valid breakpoint.
 * @param {String} breakpoint A breakpoint string.
 * @returns {undefined}
 */
const validateBreakpoint = (breakpoint) => {
  if (!breakpoint) {
    throw new Error('Please provide a breakpoint for responsiveContent helper.');
  }

  if (BREAKPOINTS.indexOf(breakpoint) === -1 && !ALIASES[breakpoint]) {
    throw new Error(`Invalid breakpoint (${breakpoint}) passed to responsiveContent helper.`);
  }
};

/**
 * Build up the responsive HTML (for a single breakpoint and content).
 * @param {String} breakpoint The breakpoint to display the content at.
 * @param {String} content The content to display.
 * @param {Object} renderSelector CSS selector to be used to render each element.
 * @returns {String} The resulting HTML.
 */
const buildHtml = (breakpoint, content, renderSelector) => {
  const {
    tag,
    class: className,
    id,
    attrs,
  } = renderSelector ? parseSelector(renderSelector) : {};
  const validBreakpoint = BREAKPOINTS.indexOf(breakpoint) !== -1 ? breakpoint : ALIASES[breakpoint];
  const attrsHtml = Object.keys(attrs).map(key => `${key}="${attrs[key]}"`).join('');

  return `<${tag || DEFAULT_TAG} class="show-for-${validBreakpoint}${className ? ` ${className}` : ''}" ${id ? `id="${id}"` : ''} ${attrsHtml}>${content}</${tag || DEFAULT_TAG}>`;
};

const helpers = {
  /**
   * Displays different content for each breakpoint (via show-for-* classes)
   * @param {String|Object} value Responsive object or string passed in to helper.
   * @param {String} [renderSelector=''] CSS selector to be used to render each element.
   * @return {String} HTML string.
   */
  responsiveContent(value, renderSelector = '') {
    const html = []; // holder for responsive HTML elements

    if (typeof value === 'object') {
      Object.keys(value).forEach((query) => {
        const queryValue = value[query];
        const queryHasMultipleBreakpoints = query.includes(BREAKPOINT_SEPARATOR);

        if (queryHasMultipleBreakpoints) {
          const breakpoints = query.split(BREAKPOINT_SEPARATOR);

          breakpoints.forEach((breakpoint) => {
            validateBreakpoint(breakpoint);
            html.push(buildHtml(breakpoint, queryValue, renderSelector));
          });

          return;
        }

        html.push(buildHtml(query, queryValue, renderSelector));
      });
    }

    if (html.length !== 0) {
      return html.join('');
    }

    return value;
  },
};

module.exports.register = (Handlebars) => {
  Object.keys(helpers).forEach((helper) => {
    Handlebars.registerHelper(helper, helpers[helper]);
  });
};

module.exports.helpers = helpers;
